import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { TGeneration } from '../../../shared/types/GenerationType'
import type { User } from '../../../shared/types/User'
import {mockGenerations} from "../../../mockGenerations.ts";

interface UserState {
  user: User;
  generations: TGeneration[]
}

const initialState: UserState = {
  user: {
    id: 1,
    balance: 0,
  },
  generations: mockGenerations,
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload
    },
    updateBalance: (state, action: PayloadAction<number>) => {
      const user = state.user
      if (!user) {
        throw new Error('User is not set')
      }
      user.balance = action.payload
    },
    setGenerations: (state, action: PayloadAction<TGeneration[]>) => {
      state.generations = action.payload
    },
    updateGenerations: (state, action: PayloadAction<TGeneration[]>) => {
      for (const updatedGen of action.payload) {
        const index = state.generations.findIndex((g) => g.id === updatedGen.id);
        if (index !== -1) {
          state.generations[index] = {
            ...state.generations[index],
            ...updatedGen,
          };
        }
      }
    },

    addGeneration: (state, action: PayloadAction<TGeneration>) => {
      state.generations.unshift(action.payload)
    },
    replaceOptimisticGeneration: (state, action: PayloadAction<{ optimisticId: number; generation: TGeneration }>) => {
      const { optimisticId, generation } = action.payload;
      const index = state.generations.findIndex((g) => g.id === optimisticId && g.isOptimistic);

      if (index !== -1) {
        state.generations[index] = generation;
      }
    },
  },
})

export const { setUser, setGenerations, addGeneration, updateGenerations, replaceOptimisticGeneration, updateBalance } = userSlice.actions

export default userSlice.reducer
